import styled from 'styled-components';

import { SkeletonElement } from '@notino/react-styleguide-v20';

export const StyledButtonLineSection = styled(SkeletonElement)`
  justify-content: center;
  margin: 1.25rem 0;
  height: 9rem;
`;
